<template>
  <div style="background-color: #f3f6fb">
    <!-- 导航 -->
    <!-- <topNavigation
      :deleteSort="[1, 2, 3,4]"
      :alginRight="true"
    >
    </topNavigation> -->
    <!-- <navigation v-if="this.$route.path != '/tagPush'"></navigation> -->
    <navigation></navigation>
    <appMain></appMain>
    <footers></footers>
  </div>
</template>
<script>
// import topNavigation from "@/components/topNavigation.vue";
import TopBanner from "@/components/TopBanner";
import appMain from "./components/appMain.vue";
import footers from "./components/footer.vue";
import Search from "@/components/Search";
// import home from '../views/homePage/homeSubpages/home.vue';
import navigation from "./components/navigationLoginLog.vue";
export default {
  name: "",
  components: {
    navigation,
    // topNavigation,
    TopBanner,
    footers,
    appMain,
    Search,
  },
  mixins: [],
  props: {},
  data() {
    return {
      assemblyList: [],
      isMoblie: false,
      isPath: "",
    };
  },
  computed: {},
  watch: {
    MobileVerification: {
      handler(to) {
        this.isMoblie = this.MobileVerification;
      },
      immediate: true,
    },
  },
  created() {
    this.isPath = this.$route.name;
  },
  mounted() { },
  methods: {},
  beforeDestroy() { },
};
</script>
<style lang="less" scoped>
.add {
  position: absolute;
  right: 0;
  top: 60px;
}

@media screen and (max-width: 769px) {
  .add {
    position: absolute;
    right: 0;
    top: 90px !important;
    bottom: 0px !important;
    display: flex;
  }
}
</style>
<style lang="less" scoped>
a {
  text-decoration: none !important;
}

/deep/.el-table th {
  background-color: #bfd7f3 !important;
  /* 修改为你想要的颜色 */
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #222a34;
}

/* 覆盖分页组件页码按钮的背景色和文字颜色 */
/deep/.pagination .el-pager li {
  background-color: #f5f5f5;
  /* 设置背景色 */
  color: #666;
  /* 设置文字颜色 */
}

/* 覆盖当前激活的页码按钮样式 */
/deep/.pagination .el-pager .active {
  background-color: #409eff;
  /* 设置背景色 */
  color: #fff;
  /* 设置文字颜色 */
}

/deep/.el-pager li {
  border: solid 1px #e8e8e8;
  border-radius: 3px;
  margin: 0px 5px;
  box-sizing: border-box;
  font-weight: normal;
}

/deep/ .el-pager li.active {
  border: none;
}

/deep/.btn-prev {
  font-weight: normal;
  border: 1px solid #e8e8e8;
  /* 边框颜色可以根据需要自定义 */
  border-radius: 2px;
  /* 可选：为分页组件添加圆角 */
  margin-right: 5px;
  padding-right: 6px;
}

/deep/.btn-next {
  font-weight: normal;
  border: 1px solid #e8e8e8;
  /* 边框颜色可以根据需要自定义 */
  border-radius: 2px;
  /* 可选：为分页组件添加圆角 */
  margin-left: 5px;
  padding-left: 6px;
}
</style>
